import { HTMLAttributes, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import TooltipIcon from '@wwt/shared/assets/icons/outline/tip.svg'

import { cn } from '@/shared/lib/cn'

interface PriceWithIconProps extends HTMLAttributes<HTMLButtonElement> {
	ref?: React.Ref<HTMLButtonElement>
	price: ReactNode
	oldPrice?: ReactNode
	className?: string
}

export const PriceWithIcon = ({
	ref,
	price,
	oldPrice,
	className,
	...props
}: PriceWithIconProps) => {
	const { t } = useTranslation('price')

	const priceForShow =
		typeof price === 'number'
			? t('price.base', { ns: 'translation', value: price })
			: price

	return (
		<button
			ref={ref}
			className={cn(
				'ts-3 flex h-full cursor-pointer items-center justify-center gap-x-2 text-black sm:flex-row sm:items-center md:justify-start',
				className
			)}
			title={t('hint.clickForOpen')}
			{...props}
		>
			<h2>{priceForShow}</h2>

			{oldPrice && (
				<div className="flex items-center">
					<span className="ts-7 text-gray-400 line-through">{oldPrice}</span>
				</div>
			)}

			<TooltipIcon className="mb-2 text-gray-300" />
		</button>
	)
}

PriceWithIcon.displayName = 'PriceWithIcon'
